var _circle, _circle2, _circle3, _circle4, _path, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_89367",
    "data-name": "Group 89367",
    xmlns: "http://www.w3.org/2000/svg",
    width: 140.36,
    height: 140.36,
    viewBox: "0 0 140.36 140.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 5.285,
    cy: 5.285,
    r: 5.285,
    transform: "translate(64.894 17.88)",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 5.285,
    cy: 5.285,
    r: 5.285,
    transform: "translate(64.894 113.178)",
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 5.285,
    cy: 5.285,
    r: 5.285,
    transform: "translate(17.244 64.895)",
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 5.285,
    cy: 5.285,
    r: 5.285,
    transform: "translate(112.542 64.895)",
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M47.16,65.834a5.274,5.274,0,0,1-1.833-10.223V22.5h3.663V55.61a5.294,5.294,0,0,1,1.483.852l14.19-8.8L66.6,50.78,52.351,59.609a5.386,5.386,0,0,1,.095.94A5.285,5.285,0,0,1,47.16,65.834Z",
    transform: "translate(23.02 9.631)",
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 5.285,
    cy: 5.285,
    r: 5.285,
    transform: "translate(42.48 23.821)",
    fill: "#fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 5.285,
    cy: 5.285,
    r: 5.285,
    transform: "translate(86.966 105.97)",
    fill: "#fff"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 5.285,
    cy: 5.285,
    r: 5.285,
    transform: "translate(25.701 88.817)",
    fill: "#fff"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 5.285,
    cy: 5.285,
    r: 5.285,
    transform: "translate(103.773 40.975)",
    fill: "#fff"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 5.285,
    cy: 5.285,
    r: 5.285,
    transform: "translate(86.966 23.822)",
    fill: "#fff"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 5.285,
    cy: 5.285,
    r: 5.285,
    transform: "translate(42.482 105.97)",
    fill: "#fff"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 5.285,
    cy: 5.285,
    r: 5.285,
    transform: "translate(25.701 40.975)",
    fill: "#fff"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 5.285,
    cy: 5.285,
    r: 5.285,
    transform: "translate(103.773 88.817)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M3.5,73.68A70.18,70.18,0,1,0,24.055,24.055,69.982,69.982,0,0,0,3.5,73.68Zm11.838,0a58.341,58.341,0,1,1,17.088,41.256A58.132,58.132,0,0,1,15.338,73.68Z",
    transform: "translate(-3.5 -3.5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clockIcon.e02424c8299d55c2f8667aa6deccc5f0.svg";
export { ForwardRef as ReactComponent };